var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.kycVerifyModalData.kycProvider === 'onfido' ? _c('KycVerifyModalOnfido') : _vm.kycVerifyModalData.kycProvider === 'jumio' ? _c('KycVerifyModalJumio') : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }